export default __webpack_public_path__ + "static/media/ResultError.daba2fb0.png";